import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/services/api.service';
import { Page } from 'src/app/models/page.model';
import { CommonService } from 'src/app/services/common.service';
import { NgxSmartModalService } from 'ngx-smart-modal';
import { DatePipe } from '@angular/common';
import { DatatableComponent } from '@siemens/ngx-datatable';
import { Subject, Subscription } from 'rxjs';

@Component({
  selector: 'app-documentgenerator',
  templateUrl: './documentgenerator.page.html',
  styleUrls: ['./documentgenerator.page.scss'],
})
export class DocumentgeneratorPage implements OnInit {
  @ViewChild("focusAlert") focusAlert: ElementRef;
  @ViewChild('tableList') tableList: DatatableComponent;
  searchText: string = '';
  filter: string = '';
  filterListValue: string = '';
  sort: string = '';
  sortListValue: string = '';
  page = new Page();
  newpage = new Page();
  preventClick: boolean = true;
  showPage: boolean = false;
  rows = [];
  columnsWidth: any = [];
  tableRow=[]
  tableRows: { [key: number]: any[] } = {};
  favoriteTableRows=[];
  searchListText: string = '';
  TemplateType: any = []
  sortingList: any = []
  expandFavorite: boolean = true;
  favoriteIcon: string = 'chevron-up-outline';
  expandNonFavorite: boolean = true;
  nonFavoriteIcon: string = 'chevron-up-outline';
  listView: boolean = true;
  searchEvent: Subject<any>;
  searchSubscription: Subscription;
  toggleSubscription: Subscription;
  resizeSubscription: Subscription;
  currentListPage = 0;
  displayTable: boolean = false;
  sizeChange:boolean = false;
  remarks: string = '';
  expandSection: { [key: number]: boolean } = {};
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.adjustColumnWidth();
  }

  @Input() rating: number = 0;

  @Output() ratingChange: EventEmitter<number> = new EventEmitter();
  constructor(private router: Router, private datePipe: DatePipe, public ngxSmartModalService: NgxSmartModalService, private route: ActivatedRoute, private _apiService: ApiService, public _commonService: CommonService) {
    this.page.pageNumber = 0;
    this.page.size = 0;
    this.page.orderBy = '';
    this.page.orderDir = '';
    this.newpage.pageNumber = 0;
    this.newpage.size = 50;
    this.searchEvent = this._commonService.searchTextValue;
  }

  public onLimitChange(limit: any): void {
    this.newpage.size = parseInt(limit, 10);
    if (this.searchListText && this.searchListText != '') {
      this.setListPage({ offset: 0 }, this.searchListText);
    } else {
      this.setListPage({ offset: 0 }, '');
    }
  }

  adjustColumnWidth() {
    if (this.tableList && window.innerWidth > 900) {
      this.sizeChange = false;
      let tableWidth = this.tableList._innerWidth - 160;
      // this.columnsWidth.FavouriteIcon = (5.4 / 100) * tableWidth;
      // this.columnsWidth.FeedbackIcon = (5.4 / 100) * tableWidth;
      this.columnsWidth.DocumentName = (60 / 100) * tableWidth;
      this.columnsWidth.DocumentTemplateTypeName = (40 / 100) * tableWidth;
    }
    if (this.tableList && window.innerWidth < 900) {
      this.sizeChange = true;
      let tableWidth = this.tableList._innerWidth;
      // this.columnsWidth.FavouriteIcon = (5.4 / 100) * tableWidth;
      // this.columnsWidth.FeedbackIcon = (5.4 / 100) * tableWidth;
      this.columnsWidth.DocumentName = (100 / 100) * tableWidth;
      this.columnsWidth.DocumentTemplateTypeName = null;
    }
    if(this.tableList){
      this.tableList.recalculate();

    }
  }

  ngOnInit() {
  }



  ionViewWillEnter() {
    this.filter = this.filter ? this.filter : '';
    this.sort = this.sort ? this.sort : '';
    this.filterListValue = this.filterListValue ? this.filterListValue : '';
    this.searchListText = this.searchListText?this.searchListText:'';
    if(this.tableList){
      this.tableList.externalSorting = true;
    }
    if (localStorage.generatorTileFilters) {
      let cacheTileValue = JSON.parse(localStorage.generatorTileFilters);
      this.searchText = cacheTileValue.searchText?cacheTileValue.searchText:'',
      this.filter = '',
      this.sort = cacheTileValue.sortLabel ? cacheTileValue.sortLabel : '',
      this.page.pageNumber = cacheTileValue.pageNumber?cacheTileValue.pageNumber:0,
      this.page.orderBy = cacheTileValue.orderBy?cacheTileValue.orderBy:'',
      this.page.orderDir = cacheTileValue.orderDir?cacheTileValue.orderDir:'',
      this.page.size = cacheTileValue.size?cacheTileValue.size:''
    }

    if(localStorage.generatorListFilters){
      let cacheListValue = JSON.parse(localStorage.generatorListFilters);
      this.searchListText = cacheListValue.searchListText ? cacheListValue.searchListText : '';
      this.filterListValue = cacheListValue.filterListId ? cacheListValue.filterListId : '';
      this.sortListValue = cacheListValue.sortList ? cacheListValue.sortList : '';
      this.currentListPage = cacheListValue.currentListPage?cacheListValue.currentListPage:0;
      this.newpage.pageNumber = cacheListValue.pageNumber?cacheListValue.pageNumber:0;
      this.newpage.orderBy = cacheListValue.orderBy?cacheListValue.orderBy:'';
      this.newpage.orderDir = cacheListValue.orderDir?cacheListValue.orderDir:'';
      this.newpage.size = cacheListValue.size?cacheListValue.size:50;
    }

    // this.setPage({ offset: 0 }, this._commonService.searchText ? this._commonService.searchText : '');
    this.sortingList = [{ Id: "ASC", Name: this._commonService.getLocalTranslation('label-azTemplate') }, { Id: "DESC", Name: this._commonService.getLocalTranslation('label-zaTemplate') }, { Id: "DESCTEMPLATE", Name: this._commonService.getLocalTranslation('label-latestTemplateModel') }];
    this.adjustColumnWidth();
    this.getTemplateType();

    if (localStorage.generatorView) {
      if (localStorage.generatorView == 'tile') {
        this.viewTile()
      } else {
        this.showPage = true;
       this.viewList();
      }
    } else {
      this.showPage = true;
      this.viewList();
    }
  }

  ionViewWillLeave() {
    this._commonService.searchText = "";
    this.searchText = "";
    this.searchListText = "";
    if(this.tableList){
      this.tableList.selected = [];
    }
    if (this.searchSubscription) {
      this.searchSubscription.unsubscribe();
    }
    if (this.toggleSubscription) {
      this.toggleSubscription.unsubscribe();
    }
    if (this.resizeSubscription) this.resizeSubscription.unsubscribe();
  }

  search() {
    Object.keys(this.expandSection).forEach(key => {
      this.expandSection[key] = false;
    });
    this.favoriteTableRows=[]
    this.tableRows=[]
    this.expandFavorite = true;
    this.favoriteIcon = 'chevron-up-outline';
    this.setPage({ offset: 0 }, this.searchText);

    if(this.filter!==undefined) this.toggleDynamicSection(this.filter)
  }

  searchList(){
    this.expandFavorite = true;
    this.favoriteIcon = 'chevron-up-outline';
    Object.keys(this.expandSection).forEach(key => {
    this.expandSection[key] = false;
  });
  this.favoriteTableRows=[]
  this.tableRows=[]
    this.setListPage({ offset: 0 }, this.searchListText);
    if(this.filterListValue!==undefined) this.toggleDynamicSection(this.filterListValue)
  }

  putValueInLocalStorage(){
    let obj = {
      searchText: this.searchText ? this.searchText : '',
      filterId: this.filter ? this.filter : '',
      sortLabel: this.sort ? this.sort : '',
      pageNumber:this.page.pageNumber?this.page.pageNumber:0,

      orderBy:this.page.orderBy?this.page.orderBy:'',
      orderDir:this.page.orderDir?this.page.orderDir:'',
      size:this.page.size?this.page.size:0

    }
    localStorage.generatorTileFilters = JSON.stringify(obj);
  }

  async setPage(pageInfo, searchText, id = null) {
    
    this._commonService.searchText = searchText;
    this.filter = this.filter ? this.filter : '';
    this.sort = this.sort ? this.sort : '';
    this._commonService.presentLoading();
    this._commonService.currentPage = pageInfo.offset;
    this.page.pageNumber = pageInfo.offset;
    this.putValueInLocalStorage();
      if (!this.showPage) {
        await this.getTemplateType();
      }
      this.showPage = true;


      this._apiService.getFavouriteDocumentTemplatesList(searchText ? searchText : "", this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size, 1, this.filter,1).then(data => {
        this.favoriteTableRows = data.body;
        this.displayTable = true;
        this._commonService.log(this.tableRows, this._commonService.LOG);
        this._commonService.dismiss();
      }).catch(err => {
        this.displayTable = true;
        this._commonService.dismiss();
        this._commonService.log(err, this._commonService.ERROR);
      })
      if (this.tableRows) {
        Object.keys(this.tableRows).forEach(key => {
        if(key===id){
          this.fetchData(key);
        }
      });
      }
    
  }

  putvaluesOnLocalStorageForList() {
    let obj = {
      searchListText: this.searchListText ? this.searchListText : '',
      filterListId: this.filterListValue ? this.filterListValue : '',
      sortList: this.sortListValue ? this.sortListValue : '',
      currentListPage: this.currentListPage?this.currentListPage:0,
      pageNumber:this.newpage.pageNumber?this.newpage.pageNumber:0,
      orderBy:this.newpage.orderBy?this.newpage.orderBy:'',
      orderDir:this.newpage.orderDir?this.newpage.orderDir:'',
      size:this.newpage.size?this.newpage.size:50
    }
    localStorage.generatorListFilters = JSON.stringify(obj);
  }

  async setListPage(pageInfo, searchText, id = null) {
    this.searchListText = searchText;
    this.filterListValue = this.filterListValue ? this.filterListValue : '';
    // this.typeListSort = this.typeListSort ? this.typeListSort : '';
    this._commonService.presentLoading();
    await this.adjustColumnWidth();
    this.currentListPage = pageInfo.offset;
    this.newpage.pageNumber = pageInfo.offset;
    // this.tableList.offset = this.newpage.pageNumber;
    this.putvaluesOnLocalStorageForList();
    
    this._apiService.getFavouriteDocumentTemplatesList(searchText ? searchText : "",this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size, 1,this.filterListValue ,1).then(data => {
      this.tableList.messages.emptyMessage = this._commonService.getLocalTranslation('label-itemUnavailable');
      this.favoriteTableRows = data.body;
      if (!this.tableList.element.className.includes("border-header border-footer")) this.tableList.element.className += " border-header border-footer";
      this.displayTable = true;
      this._commonService.log(this.tableRows, this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this.displayTable = true;
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    })
    if (this.tableRows) {
      Object.keys(this.tableRows).forEach(key => {
      if(key===id){
        this.fetchData(key);
      }
    });
    }
    
    
  }

  showWizard(item) {
    this.startDocument(item.DocumentTemplateId, item.DocumentTemplateVersionId)
    // this.router.navigate(['/documentgenerator/wizard/' + item.DocumentTemplateId + '/' + item.DocumentTemplateVersionId]);
  }

  async startDocument(templateId, versionId) {
    try {
      this._commonService.presentLoading();
      var obj = {
        DocumentTemplateId: templateId,
        DocumentTemplateVersionId: versionId,
        DocumentName: this.datePipe.transform(new Date(), 'ddMMyyyy_HHmmss')
      }
      let res = await this._apiService.postDocument(obj)
      if (res) {
        sessionStorage.DocumentId = res.DocumentId;
        sessionStorage.DocumentVersionId = res.DocumentVersionId;
        this._commonService.dismiss();
        this.router.navigate(['/documentgenerator/wizard/' + templateId + '/' + versionId]);
        //this.getDocumentValues();
      }
    } catch (error) {
      // if(error.includes('402 Payment Required')){
      //   console.log("The test case",error);
      //   if(localStorage.roleCode == 'UserRole_CustomerAdmin'){
      //     this.router.navigate(["maintenance/domains/" + localStorage.domainId]);
      //   }
      // }
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

  onActivate(event) {
    if (event.type == 'click' && event.cellIndex != 1 && event.cellIndex != 0) {
      if (this.preventClick) {
        this.startDocument(event.row.DocumentTemplateId, event.row.DocumentTemplateVersionId)
      }
    }
  }

  async onSort(event) {
    const sort = event.sorts[0];
    this.newpage.orderBy = sort.prop.toLowerCase();
    this.newpage.orderDir = sort.dir;
    await this.setListPage({ offset: this.newpage.pageNumber }, this.searchListText);
  }
  async onDynamicSort(event,templateTypeId) {
    
    const sort = event.sorts[0];
    this.newpage.orderBy = sort.prop.toLowerCase();
    this.newpage.orderDir = sort.dir;
    this._apiService.getNonFavouriteDocumentTemplatesList('', this.newpage.orderBy, this.newpage.orderDir, this.newpage.pageNumber + 1, this.newpage.size, 1, templateTypeId,1).then(data => {
      this.tableRows[templateTypeId] = data.body;
      this.displayTable = true;
      this._commonService.log(this.tableRows[templateTypeId], this._commonService.LOG);
      this._commonService.dismiss();
    }).catch(err => {
      this.displayTable = true;
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    });
  }

  public noopComparator(): number {
    return 0;
 }


  toggle(Id, status) {
    if (status == 'makeFovorite') {
      this.rows.forEach(async (element) => {
        if (element.DocumentTemplateId == Id) {
          element.isFavorite = 'true'
        }
      });
      this.favouriteDocument(Id, true);
    } else if (status == 'removeFavorite') {
      this.rows.forEach(async (element) => {
        if (element.DocumentTemplateId == Id) {
          element.isFavorite = 'false';
        }
      });
      this.favouriteDocument(Id, false);
    }
    // this.isShow = ! this.isShow
  }

    async makeFavourite(id, value,documentID=null) {
     
    try {
      let data = {
        "isFavorite": value == true ? "1" : "0"
      }
      this._commonService.presentLoading();
      this._apiService.postFovouriteDocument(data, id).then(()=>{
      
        this.fetchData(documentID)
        if(localStorage.generatorView == "tile"){
          this.setPage({ offset: 0 }, this.searchText)
        }
        else{

          this.setListPage({ offset: 0 }, this.searchListText);
          
        }
      })
      
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  async favouriteDocument(id, status) {
    try {
      let data = {
        "isFavorite": status == true ? "1" : "0"
      }
      await this._apiService.postFovouriteDocument(data, id);

    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }



  onChangeSorting(event) {
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    this.favoriteTableRows=[];
    if (event == 'ASC') {
      this.page.orderBy = 'name',
        this.page.orderDir = 'asc'
      this.setPage({ offset: 0 }, this.searchText);
      if(this.filter!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filter)}
    }

    if (event == 'DESC') {
      this.page.orderBy = 'name',
        this.page.orderDir = 'desc'
      this.setPage({ offset: 0 }, this.searchText);
      if(this.filter!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filter)}
    }

    if (event == 'DESCTEMPLATE') {
      this.page.orderBy = 'documentdatecreated',
        this.page.orderDir = 'desc'
      this.setPage({ offset: 0 }, this.searchText);
      if(this.filter!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filter)}
    }

    if (!event) {
      this.page.orderBy = '',
        this.page.orderDir = ''
      this.setPage({ offset: 0 }, this.searchText);
      if(this.filter!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filter)}
    }
    if(this.filter!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filter)}

  }

  onChangeSortingList(event) {
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    this.favoriteTableRows=[];
    
    if (event == 'ASC') {
      this.page.orderBy = 'name',
        this.page.orderDir = 'asc'
      this.setListPage({ offset: 0 }, this.searchListText);
      if(this.filterListValue!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filterListValue)}
    }

    if (event == 'DESC') {
      this.page.orderBy = 'name',
        this.page.orderDir = 'desc'
        this.setListPage({ offset: 0 }, this.searchListText);
        if(this.filterListValue!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filterListValue)}
      }

    if (event == 'DESCTEMPLATE') {
      this.page.orderBy = 'documentdatecreated',
        this.page.orderDir = 'desc'
        this.setListPage({ offset: 0 }, this.searchListText);
        if(this.filterListValue!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filterListValue)}
      }

    if (!event) {
      this.page.orderBy = '',
        this.page.orderDir = ''
        this.setListPage({ offset: 0 }, this.searchListText);
        if(this.filterListValue!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filterListValue)}
      }
      if(this.filterListValue!==undefined) {this.tableRows=[]; this.toggleDynamicSection(this.filterListValue)}
  }

  onChangeFilter(event) {
  this.favoriteTableRows=[]
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    Object.keys(this.expandSection).forEach(key => {
      this.expandSection[key] = false;
    });
    this.filter = event || '';
    if(this.filter=='') {
      this.tableRows=[];
    }
    this.setPage({ offset: 0 }, this.searchText);
    this.toggleDynamicSection(this.filter)
  }
  onChangeListFilter(event) {
    this.favoriteTableRows=[]
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    Object.keys(this.expandSection).forEach(key => {
      this.expandSection[key] = false;
    });
    this.filterListValue = event || '';
    if(this.filterListValue=='') {
      this.tableRows=[];
    }
    this.setListPage({ offset: 0 }, this.searchListText);
    this.toggleDynamicSection(this.filterListValue)
   
    
  }

  async getTemplateType() {
    try {
      this._commonService.presentLoading();
      let res = await this._apiService.getTemplateType();
      this.TemplateType = res.body;
      this._commonService.dismiss();

    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }
  }


  openRatingModal(row) {
    this.rating = 0;
    this.remarks = ''
    this.ngxSmartModalService.getModal('DocumentGeneratorRatingModal').open();
    setTimeout(() => {
      this.focusAlert.nativeElement.focus();
      document.getElementById('alertFocus').classList.add("rating-alert-button");
    }, 100);
  }
  rate(index: number) {
    this.rating = index;
    this.ratingChange.emit(this.rating);
  }

  getColor(index: number) {
    if (index) {
      if (this.isAboveRating(index)) {
        return "../assets/star_favorite.svg";
      } else {
        return "../assets/star_favorite_fill.svg";
      }
    } else {
      return "../assets/star_favorite.svg";
    }

  }

  isAboveRating(index: number): boolean {
    return index > this.rating;
  }
  async RateAndCloseModal() {
    this.ngxSmartModalService.getModal('DocumentGeneratorRatingModal').close();
    try {
      this._commonService.presentLoading();
      let data = {
        "ModuleId": "dadfe1ac-b84a-43d2-9f8e-1f6d273efa59",
        "UserRating": this.rating ? this.rating : null,
        "UserRemark": this.remarks ? this.remarks : null,
        "ExternalRefId": null
      }
      let res = await this._apiService.postUserRatings(data);
      if (res.id) {

      }
      this._commonService.dismiss();
      this._commonService.showToast(this._commonService.getLocalTranslation('label-feedbackGiven'));
      this._commonService.log(data, this._commonService.LOG);
    } catch (error) {
      this._commonService.dismiss();
      this._commonService.log(error, this._commonService.ERROR);
    }

  }

  get filterFavouriteList() {
    return this.rows.filter(x => x.isFavorites == 'true');
  }

  get filterList() {
    return this.rows.filter(x => x.isFavorite == 'false');
  }

  toggleSection(sectionName) {
    if (sectionName == "favorite") {
      if (this.expandFavorite) {
        this.expandFavorite = false;
        this.favoriteIcon = 'chevron-down-outline';
        
      } else {
        this.expandFavorite = true;
        this.favoriteIcon = 'chevron-up-outline';
        
      }
    }

    // if (sectionName == "nonFavorite") {
    //   if (this.expandNonFavorite) {
    //     this.expandNonFavorite = false;
    //     this.nonFavoriteIcon = 'chevron-down-outline';
    //   } else {
    //     this.expandNonFavorite = true;
    //     this.nonFavoriteIcon = 'chevron-up-outline';
    //   }
    // }

  }


  async closeRatingModal() {
    this.ngxSmartModalService.getModal('DocumentGeneratorRatingModal').close();
  }

  viewTile() {
    this.favoriteTableRows=[];
    this.tableRows={};
    this.expandSection={}
    this.listView = true;
    localStorage.generatorView = "tile";
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    this.setPage({ offset: 0 }, this.searchText);
    if(this.filter!==undefined){this.tableRows=[];this.toggleDynamicSection(this.filter)}
  }

  viewList() {
    this.favoriteTableRows=[];
    this.tableRows={};
    this.expandSection={};
    this.listView = false;
    localStorage.generatorView = "list";
    this.expandFavorite=true;
    this.favoriteIcon = 'chevron-up-outline';
    this.displayTable = false;
    this._commonService.presentLoading();
    setTimeout(() => {
      if (this.searchEvent) {
        this.searchSubscription = this.searchEvent.subscribe(event => {
          this.setListPage({ offset: 0 }, event);
          this.searchListText = event;
        });
      }
      this.setListPage({ offset: this.currentListPage ? this.currentListPage : 0 }, this.searchListText && this.searchListText != '' ? this.searchListText : '');
      this.toggleSubscription = this._commonService.onToggle.subscribe(event => {
        setTimeout(() => {
          this.tableRow = [...this.tableRow];
          if (this.tableList) this.tableList.recalculate();
          this.adjustColumnWidth();
        }, 0)
      });
      this.resizeSubscription = this._commonService.onResize.subscribe(event => {
        this.adjustColumnWidth();
      });
      if(this.filterListValue!==undefined){this.tableRows=[];this.toggleDynamicSection(this.filterListValue)}
    }, 1000);
  }
  toggleDynamicSection(id) {
    this.expandSection[id] = !this.expandSection[id];
    if (!this.tableRows[id]) {
      this.tableRows[id] = [];
    }
    if (this.expandSection[id] && this.tableRows[id].length === 0) {
      this.fetchData(id);
    }
    
  }
  fetchData(templateTypeId) {
    let searchText=''
    if(localStorage.generatorView=='list'){
      searchText =this.searchListText?this.searchListText: ''; 

    }else{
      searchText =this.searchText?this.searchText: ''; 

    }
    this._commonService.presentLoading();
    this._apiService.getNonFavouriteDocumentTemplatesList(searchText, this.page.orderBy, this.page.orderDir, this.page.pageNumber + 1, this.page.size, 1, templateTypeId,1).then(data => {
      this.tableRows[templateTypeId] = data.body;
      // if(templateTypeId){        
      //     this.tableRows[''] = this.tableRows[''].filter(
      //       (row: any) => !data.body.some((obj: any) => JSON.stringify(obj) === JSON.stringify(row))
      //     );
      // }        
      
      this.displayTable = true;
      this._commonService.log(this.tableRows[templateTypeId], this._commonService.LOG);
      this._commonService.dismiss();
      let groupedObject;
      if((this.filter===''|| this.filterListValue==='') && searchText && !templateTypeId){
        groupedObject = this.tableRows[''].reduce((acc, item) => {
          const key = item.DocumentTemplateTypeId;
          if (!acc[key]) {
              acc[key] = [];
          }
          acc[key].push(item);
          return acc;
        }, {});
        // Merging the new data into tableRows
        for (const key in groupedObject) {
          const numericKey = key;
          
          if (!this.tableRows[numericKey]) {
              this.tableRows[numericKey] = []; // Initialize if not present
          }

          this.tableRows[numericKey].push(...groupedObject[numericKey]); // Append new items
        }

        Object.keys(groupedObject).forEach(key => {
          this.expandSection[key] = true;
        });
      }

    }).catch(err => {
      this.displayTable = true;
      this._commonService.dismiss();
      this._commonService.log(err, this._commonService.ERROR);
    });
   
  }
}
